import { forwardRef } from 'react';
import ReactInputMask, { Props as InputMaskProps } from 'react-input-mask';

import { TextInput } from '@/shared/ui';

import { FormInputProps } from '../FormInput/FormInput';

interface FormatChars {
  [key: string | number]: string | RegExp | undefined;
}

export type MaskedTextInputProps = FormInputProps &
  React.ComponentPropsWithoutRef<'input'> &
  Partial<InputMaskProps> &
  Partial<{ formatChars?: FormatChars }>;

export const MaskedTextInput = forwardRef<HTMLInputElement, MaskedTextInputProps>(
  ({ mask, maskChar = null, ...restProps }, ref) => {
    if (!mask) {
      return <></>;
    }

    const renderInput = (inputProps: any) => <TextInput {...inputProps} ref={ref} />;

    return (
      <ReactInputMask
        {...restProps}
        mask={mask}
        maskChar={maskChar}
        // eslint-disable-next-line react/no-children-prop
        children={renderInput as any}
      />
    );
  },
);
